import { faFileArrowUp } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { GEO_TARGETS_TYPES } from "form/model"
import { getGeoTargetsFileImport, setGeoTargetsFileImportPopupVisibility } from "form/tools/geo-targets-file-import"
import React from "react"
import { connect } from "react-redux"
import { SelectButton } from "ui/components/SelectButton"
import { MAX_PHONE_WIDTH_IN_PX } from "ui/model"
import { GeoTargetsImportPopup } from "./GeoTargetsImportPopup"

interface IGeoTargetsImportButtonProps {
  containerWidth: number
  isPopupOpened: boolean
}

const GeoTargetsImportButtonFn = React.memo(({ containerWidth, isPopupOpened }: IGeoTargetsImportButtonProps) => {
  if (containerWidth <= MAX_PHONE_WIDTH_IN_PX) {
    return null
  }
  return (
    <>
      {isPopupOpened && <GeoTargetsImportPopup />}
      <SelectButton
        id="geo-target-import-button"
        icon={faFileArrowUp}
        title={translate("label.import")}
        items={[
          {
            label: translate("campaign.geo-targets.coordinate.import.button"),
            disabled: isPopupOpened,
            onClick: () => setGeoTargetsFileImportPopupVisibility(true, GEO_TARGETS_TYPES.COORDINATE)
          },
          {
            label: translate("campaign.geo-targets.postal-code.import.button"),
            disabled: isPopupOpened,
            onClick: () => setGeoTargetsFileImportPopupVisibility(true, GEO_TARGETS_TYPES.POSTAL_CODE)
          }
        ]}
      />
    </>
  )
})

export const GeoTargetsImportButton = connect(
  (state: IRootState): IGeoTargetsImportButtonProps => ({
    containerWidth: state.ui.container.width,
    isPopupOpened: getGeoTargetsFileImport(state).isPopupOpened
  })
)(GeoTargetsImportButtonFn)
